import React from "react";

const SimpleLayout = ({ children }) => (
  <div className="simple-layout">{children}</div>
);

export default SimpleLayout;
